import styled from 'styled-components';
import { SIZE } from '@app/src/ui';

interface Props {
  transition: boolean;
  width: number;
  moveRight?: boolean;
  minWidth: number;
}

export const Wrapper = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-transform: translateZ(0);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 2000;
  top: 0;
  left: ${(props: Props) => props.transition
    ? '0'
    : '-100%'};
  right: ${(props: Props) => props.transition
    ? '0'
    : '-100%'};
  ${(props: Props) => props.moveRight ? `
    left: revert;
  `: `
    right: revert;
  `}

  transition: all .4s ease;
  background-color: #FFFFFF;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: ${(props: Props) => props.minWidth && `${props.minWidth}px`};
    left: ${(props: Props) => props.transition
      ? '0'
      : `-${props.minWidth}px`};
    right: ${(props: Props) => props.transition
      ? '0'
      : `-${props.minWidth}px`};
    ${(props: Props) => props.moveRight ? `
      left: revert;
    `: `
      right: revert;
    `}
  }
`;

export const ShadowBackGround = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: ${(props: Props) => props.transition && '#000000'};
  opacity: 0.5;
  transition: all .4s ease;
  pointer-events: ${(props: Props) => props.transition
    ? 'auto'
    : 'none'};
`;

export const ButtonWrapper = styled.span`
  cursor: pointer;
  position: sticky;
  z-index: 4000;
  left: 18px;
  top: 14px;
  
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    top: 21px;
  }
`;